import React, { type FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AppDocumentTitle } from "@app/document-title";
import { MobileNavBar } from "../mobile-nav-bar";
import "./MobileAppShell.scss";

/**
 * Мобильный shell приложения: заголовок, контент, нижняя навигация.
 */
export const MobileAppShell: FC = () => (
    <div className="mobile_app_shell">
        <AppDocumentTitle />
        <Suspense fallback={<></>}>
            <div className="mobile_app_shell__outlet custom_scrollbar">
                <Outlet />
            </div>
            <MobileNavBar />
        </Suspense>
    </div>
);
